<!--
 * @Author       : Tom
 * @Date         : 2019-12-16 11:37:53
 * @LastEditors  : Tom
 * @LastEditTime : 2020-01-15 20:02:24
 * @FilePath     : /shop_front_end/src/views/shop_set/index.vue
 * @Description  : 
 -->
<template>
	<div>
		<a-tabs :activeKey="activeKey" @change="handCut">
			<a-tab-pane tab="店铺信息" key="1">
				<a-card title="店铺信息" :bordered="false" v-if="cardHeight" style="overflow-y: auto;" :style="{height: cardHeight+'px'}">
					<a-button type="primary" ghost class="btn" slot="extra" @click="logOut">店铺注销</a-button>
					<a-button type="primary" slot="extra" @click="onEditor">编辑</a-button>

					<a-form class="storedata">
						<a-form-item label="店铺头像" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
							<a-avatar :size="64" icon="user" v-if="!userimg" />
							<a-avatar :size="64" icon="user" v-else :src="userimg" />
						</a-form-item>

						<a-form-item label="店铺名称" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
							<span>{{ name }}</span>
						</a-form-item>

						<a-form-item label="店铺信息" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
							<span>{{ shop_information }}</span>
						</a-form-item>

						<a-form-item label="经营范围" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
							<span>{{ shop_range }}</span>
						</a-form-item>

						<a-form-item label="营业状态" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
							<span>{{ is_open == 1 ? '营业中' : '打烊' }}</span>
						</a-form-item>

						<a-form-item label="用户姓名" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
							<span>{{ realname }}</span>
						</a-form-item>

						<a-form-item label="身份证号" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
							<span>{{ ID_number }}</span>
						</a-form-item>

						<a-form-item label="联系电话" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
							<span>{{ tel }}</span>
						</a-form-item>

						<a-form-item label="联系地址" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
							<!--          <span>{{ address }}</span>-->
							<span>{{ sheng }}{{ shi }}{{ xian }}{{ address }}</span>
						</a-form-item>
					</a-form>
				</a-card>
			</a-tab-pane>

			<a-tab-pane tab="PC端轮播图设置" key="2">
				<!-- 操作栏 -->
				<div class="handle"><a-button @click="onNavJump('shopset/addImg')">添加轮播图</a-button></div>

				<!-- 表格 -->
				<div id="tabHeight">
					<a-table v-if="tabHeight!=0" :scroll="{ x: 1050,y: tabHeight }" :loading="loading" :columns="columns" :dataSource="dataSource" :pagination="pagination" @change="onChangeload">
						<span slot="status" slot-scope="text">{{ text.status == 0 ? '未启用' : text.status == 1 ? '已启用' : text.status == 2 ? '已禁用' : '已结束' }}</span>
					
						<span slot="image" slot-scope="text"><img :src="text.image" class="table-imgurl" /></span>
					
						<span slot="action" slot-scope="text">
							<div>
								<a-button icon="arrow-up" size="small" @click="up(text.id)">置顶</a-button>
								<a-divider type="vertical" />
								<a-button icon="form" size="small" @click="onNavJump('shopset/modifyImg?id=' + text.id)">编辑</a-button>
								<a-divider type="vertical" />
								<a-button icon="delete" size="small" @click="deletePro('single', text.id)">删除</a-button>
							</div>
						</span>
					</a-table>
				</div>
			</a-tab-pane>
			
			<a-tab-pane tab="移动端轮播图设置" key="3">
				<!-- 操作栏 -->
				<div class="handle"><a-button @click="onNavJump('shopset/addImg')">添加轮播图</a-button></div>
			
				<!-- 表格 -->
				<div id="tabHeight1">
					<a-table v-if="tabHeight!=0" :scroll="{ y: tabHeight }" :loading="loading" :columns="columns" :dataSource="dataSource" :pagination="pagination" @change="onChangeload">
						<span slot="status" slot-scope="text">{{ text.status == 0 ? '未启用' : text.status == 1 ? '已启用' : text.status == 2 ? '已禁用' : '已结束' }}</span>
								
						<span slot="image" slot-scope="text"><img :src="text.image" class="table-imgurl" /></span>
								
						<span slot="action" slot-scope="text">
							<div>
								<a-button icon="arrow-up" size="small" @click="up(text.id)">置顶</a-button>
								<a-divider type="vertical" />
								<a-button icon="form" size="small" @click="onNavJump('shopset/modifyImg?id=' + text.id)">编辑</a-button>
								<a-divider type="vertical" />
								<a-button icon="delete" size="small" @click="deletePro('single', text.id)">删除</a-button>
							</div>
						</span>
					</a-table>
				</div>
			</a-tab-pane>
			
			<a-tab-pane tab="修改密码" key="4">
				<div class="mimaBox">
					<div class="row">
						<div class="row_left">
							<span>*</span>
							原密码：
						</div>
						<div class="row_right">
							<a-input type="password" v-model="pswd_y" style="width:320px;" placeholder="请输入原密码"></a-input>
						</div>
					</div> 
					<div class="row">
						<div class="row_left">
							<span>*</span>
							新密码：
						</div>
						<div class="row_right">
							<a-input type="password" v-model="pswd_new" style="width:320px;" placeholder="请输入新密码"></a-input>
						</div>
					</div> 
					<div class="row">
						<div class="row_left">
							<span>*</span>
							确认密码：
						</div>
						<div class="row_right">
							<a-input type="password" v-model="pswd_new1" style="width:320px;" placeholder="请再次输入新密码"></a-input>
						</div>
					</div> 
					
					<div class="positionBottom">
						<a-button type="primary" @click="saveMima">确定</a-button>
					</div>
				</div>
				
			</a-tab-pane>
		</a-tabs>
	</div>
</template>

<script>
const columns = [
	{
		title: 'ID',
		key: 'id',
		dataIndex: 'id',
		width: 100
	},
	{
		title: '图片',
		key: 'image',
		scopedSlots: { customRender: 'image' },
		width: 200
	},
	{
		title: '链接',
		key: 'url',
		dataIndex: 'url',
		width: 300
	},
	{
		title: '添加时间',
		key: 'add_date',
		dataIndex: 'add_date',
		width: 170
	},
	{
		title: '操作',
		key: 'action',
		scopedSlots: { customRender: 'action' },
		width: 280,
		fixed: 'right'
	}
];

export default {
	data() {
		return {
			userimg: '',
			name: '',
			realname: '',
			shop_information: '',
			shop_range: '',
			tel: '',
			address: '',
			ID_number: '',

			loading: true,
			columns,
			dataSource: [],
			pagination: {},
			selectedRowKeysA: [],
			selectedRowA: [],
			activeKey: '1',
			is_open: '',
			
			sheng: '',
			shi: '',
			xian: '',
			
			cardHeight: '',
			
			tabHeight: 0,
			
			pswd_y: '',
			pswd_new: '',
			pswd_new1: '',
		};
	},
	mounted() {
		
		this.$nextTick(()=>{
			let viewHeight = document.querySelectorAll('.ant-layout')[0].clientHeight
			
			this.cardHeight = viewHeight - 64 - 42 - 80
		})
		
		if (localStorage.getItem('activeKey')) {
			this.activeKey = localStorage.getItem('activeKey');
			localStorage.removeItem('activeKey');
		}
		this.initPage();
	},
	methods: {
		saveMima(){
			if(!this.pswd_y){
				this.$message.warning('请输入原密码')
				return
			}
			if(!this.pswd_new){
				this.$message.warning('请输入新密码')
				return
			}
			if(!this.pswd_new1){
				this.$message.warning('请输入确认密码')
				return
			}
			if(this.pswd_new != this.pswd_new1){
				this.$message.warning('确认密码不一致')
				return
			}
			
			let data = {
				j_password: this.pswd_y, // 旧密码
				x_password: this.pswd_new // 新密码
			}
			this.$request.post('?module=pc_api&action=Mch&app=change_Password',data).then(res => {
				let { code, message } = res;
				if (code === 200) {
					this.$message.success(message);
					
					this.pswd_y = ''
					this.pswd_new = ''
					this.pswd_new1 = ''
					
					this.handCut('1')
				} else {
					this.$message.error(message);
				}
			});
		},
		logOut() {
			this.$confirm({
				title: '提示',
				content: '确认要注销此店铺吗？',
				okText: '确认',
				cancelText: '取消',
				onOk: () => {
					this.$request.post('?module=pc_api&action=Mch&app=cancellation_shop&shop_id=2').then(res => {
						let { code, message } = res;
						if (code === 200) {
							this.$message.success('注销成功');
							setTimeout(()=>{
								this.$router.push('/login');
							},1000)
						} else {
							this.$message.error(message);
						}
					});
				}
			});
		},
		deletePro(type, id) {
			let data;
			if (type == 'all') {
				if (this.selectedRowA.length == 0) {
					return;
				}

				let result = Array.from(this.selectedRowA, item => item.id);
				data = {
					id: result.join(',')
				};
			} else {
				data = { id };
			}
			
			if(this.activeKey == 2){
				data.type = 4
			}

			this.$request.get('?module=pc_api&action=Mch&app=banner_del', { params: data }).then(res => {
				if (res.code == 200) {
					this.$message.success(res.message);
					this.initGoods();
				} else {
					this.$message.warning(res.message);
				}
			});
		},
		up(id) {
			this.$request.get('?module=pc_api&action=Mch&app=banner_stick&id=' + id).then(res => {
				let { code, message, data } = res;
				if (code === 200) {
					this.initGoods();
				} else {
					this.$message.warning(message);
				}
			});
		},
		onNavJump(url) {
			localStorage.setItem('activeKey', this.activeKey);
			this.$router.push(url);
		},
		onSelectChangeA(selectedRowKeys, selectedRow) {
			this.selectedRowKeysA = selectedRowKeys;
			this.selectedRowA = selectedRow;
		},
		onChangeload(pagination) {
			this.initGoods({ page: pagination.current, ...pagination });
		},
		initGoods(page = {}, current = 1) {
			this.loading = true;

			let data = {
				...page
			};
			
			if(this.activeKey == 2){
				data.type = 4
			}
			
			this.$nextTick(()=>{
				if(this.tabHeight == 0){
					if(document.getElementById('tabHeight')){
						this.tabHeight = document.getElementById('tabHeight').clientHeight - 120
					}else if(document.getElementById('tabHeight1')){
						this.tabHeight = document.getElementById('tabHeight1').clientHeight - 120
					}
				}
			})

			this.$request.get('?module=pc_api&action=Mch&app=banner_list', { params:data }).then(res => {
				let { code, message, data } = res;
				if (code === 200) {
					this.loading = false;
					let pages = {
						total: data.total,
						current: data.page || current
					};

					Object.assign(this, {
						dataSource: data.list,
						pagination: pages
					});
				} else {
					this.$message.warning(message);
				}
			});
		},
		handCut(key) {
			this.activeKey = key;
			if(key == 1){
				this.initPage();
			}else{
				this.loading = true;
				this.dataSource = [];
				this.pagination = {};
				this.initGoods();
			}
			
			this.pswd_y = ''
			this.pswd_new = ''
			this.pswd_new1 = ''
		},
		onEditor() {
			this.$router.push('shopset/editor');
		},
		initPage() {
			if (this.activeKey != '1') {
				this.initGoods();
				return;
			}

			this.$request.get('?module=pc_api&action=Mch&app=Index&shop_id=2').then(res => {
				let { code, message, data } = res;

				if (code === 200) {
					if (data.length) {
						let { sheng, shi, xian, logo, name, realname, shop_information, shop_range, tel, address, ID_number, is_open } = data[0];
						Object.assign(this, {
							userimg: logo,
							name: name,
							realname: realname,
							shop_information: shop_information,
							shop_range: shop_range,
							tel: tel,
							address: address,
							ID_number: ID_number,
							is_open: is_open,
							sheng: sheng,
							shi: shi,
							xian: xian,
						});
					}
				} else {
				}
			});
		}
	}
};
</script>

<style lang="less">
.storedata {
	margin-top: 40px;

	span {
		font-size: 14px;
		font-weight: 400;
		color: rgba(50, 53, 68, 1);
	}
}
.btn {
	margin: 0 10px;
}

.handle {
	padding: 16px 20px;
	display: flex;
	align-items: center;
	background-color: #fafafa;
}

.table-imgurl {
	width: 160px;
	height: 60px;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
	text-align: center;
}

.ant-table-thead > tr > th{
	background-color: #FFFFFF;
}

.ant-layout{
	height: 100vh;
}

.ant-layout-content{
	flex: 1;
	overflow: hidden;
	
	>div{
		height: 100%;
	}
	
	.ant-tabs{
		display: flex;
		flex-direction: column;
		height: 100%;
		
		.ant-tabs-content{
			flex: 1;
			
			.ant-tabs-tabpane-active{
				overflow-y: auto;
			}
		}
	}
}

.ant-tabs-bar{
	margin-bottom: 0;
}

.ant-tabs .ant-tabs-top-content > .ant-tabs-tabpane{
	display: flex;
	flex-direction: column;
}

#tabHeight,#tabHeight1{
	flex: 1
}

.ant-table-tbody > tr > td{
	word-break: break-all;
}

.mimaBox{
	padding: 40px 60px;
	
	.row{
		display: flex;
		align-items: center;
		margin-bottom: 20px;
		
		&_left{
			width: 80px;
			text-align: right;
			line-height: 32px;
			margin-right: 5px;
			
			span{
				color: #FF3333;
			}
		}
	}
	
	.positionBottom{
		display: flex;
		justify-content: flex-end;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 20px;
		border-top: 1px solid #E9ECEF;
		
		.ant-btn{
			width: 100px;
			height: 32px;
			padding: 0;
		}
	}
}

.ant-tabs-nav .ant-tabs-tab{
	padding: 20px 0;
	margin: 0 20px;
}

</style>
